export const INCOMING_ANALYSIS_ALERT_TITLE = 'Inkommande analys!'
export const INCOMING_LEFT_ANALYSIS_ALERT_TITLE  = 'Inkommande analys (Vänster provrör)!'
export const INCOMING_RIGHT_ANALYSIS_ALERT_TITLE  = 'Inkommande analys (Höger provrör)!'
export const INCOMING_ANALYSIS_ALERT_BODY = 'Ny inkommande analys, vill du rensa?'